<template>
  <div class="container">
    <div class="user">
      <h1 class="user-header">DOKDO</h1>
      <div
        v-if="user_image != ''"
        class="user-default-img"
        v-bind:style="{ 'background-image': 'url(' + this.user_image + ')' }"
      ></div>
      <div v-else class="user-default-img"></div>
      <h2 class="user-name">{{ user_name }}</h2>
      <p>독도 배움이</p>
      <!--<mypage class="login-mypage"></mypage>-->
    </div>
    <input
      class="inputprscod"
      :value="presscode"
      @input="(e) => (presscode = e.target.value)"
      placeholder="CODE"
    />
    <p class="inputprscod-desc">{{ inputprscod_desc }}</p>
    <router-link to="/tutorial" v-if="is_resgist_presscode" class="linkbtn"
      >확인</router-link
    >
    <router-link to="/beforetuto" v-else class="nullbtn">확인</router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import mypage from './mypage'
/* eslint-disable */
export default {
  components: {
    mypage,
  },
  data() {
    return {
      inputprscod_desc: "코드를 입력하고 확인을 누르세요",
      is_resgist_presscode: false,
    };
  },
  computed: {
    presscode: {
      get() {
        return this.$store.state.session_eventcode;
      },
      set(value) {
        console.log(value);
        this.$store.commit("Seteventcode", value);
      },
    },
    ...mapGetters(["user_name", "user_image", "session_player"]),
  },
  created() {
    //this.$store.dispatch('loadUserinfo')
  },
  // 로그인 화면처럼 너무 서버에 많이 요청하지 않도록 해아하나 store에 있는 action과 state또한 가지고 와야 한다.
  watch: {
    // 질문이 변경될 때 마다 이 기능이 실행됩니다.
    presscode: function (newQuestion) {
      this.inputprscod_desc = "입력을 기다리는 중...";
      this.getAnswer();
    },
  },
  methods: {
    // _.debounce는 lodash가 제공하는 기능으로
    // 특히 시간이 많이 소요되는 작업을 실행할 수 있는 빈도를 제한합니다.
    // 이 경우, 우리는 yesno.wtf/api 에 액세스 하는 빈도를 제한하고,
    // 사용자가 ajax요청을 하기 전에 타이핑을 완전히 마칠 때까지 기다리길 바랍니다.
    // _.debounce 함수(또는 이와 유사한 _.throttle)에 대한
    // 자세한 내용을 보려면 https://lodash.com/docs#debounce 를 방문하세요.
    getAnswer: _.debounce(
      function () {
        this.inputprscod_desc = "검색중...";
        var vm = this;
        axios
          .get(
            `http://dokdo.nolple.com:8000/session/eventcode/${this.session_player}/${this.presscode}`
          )
          .then(function (response) {
            if (response.data.result == 0) {
              vm.inputprscod_desc = "대한민국 동쪽 끝에 자리한 섬의 이름은?";
              vm.is_resgist_presscode = false;
            } else {
              vm.is_resgist_presscode = true;
              vm.inputprscod_desc = "올바른 CODE 입니다. 게임을 시작하세요!";
              vm.$store.commit("SetPE", response.data.result);
            }
          })
          .catch(function () {
            vm.inputprscod_desc = "CODE를 입력해주세요";
          });
      },
      // 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
      500
    ),
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/beforeTutorial.vue